const MAX_DEVICE_NAME_LENGTH = 80;
function clean(value) {
    const trimmed = value?.trim();
    return trimmed ? trimmed.slice(0, MAX_DEVICE_NAME_LENGTH).trim() : null;
}
function titleCaseManufacturer(value) {
    const manufacturer = clean(value);
    if (!manufacturer)
        return null;
    if (manufacturer === manufacturer.toLowerCase() || manufacturer === manufacturer.toUpperCase()) {
        return manufacturer
            .toLowerCase()
            .replace(/(^|[\s-])\p{L}/gu, (letter) => letter.toUpperCase());
    }
    return manufacturer[0].toUpperCase() + manufacturer.slice(1);
}
function formFactorLabel(formFactor) {
    if (formFactor === "phone")
        return "Phone";
    if (formFactor === "tablet")
        return "Tablet";
    if (formFactor === "tv")
        return "TV";
    if (formFactor === "computer")
        return "Computer";
    return "Device";
}
function webOperatingSystemLabel(operatingSystem) {
    const normalized = operatingSystem.trim().toLowerCase();
    if (normalized === "macos" || normalized === "mac os")
        return "Mac";
    if (normalized === "windows")
        return "Windows";
    if (normalized === "linux")
        return "Linux";
    if (normalized === "ios")
        return "iPhone";
    if (normalized === "ipados")
        return "iPad";
    if (normalized === "android")
        return "Android";
    return clean(operatingSystem) ?? "Web";
}
/** Precise primary label used in device lists and device-management controls. */
export function deviceListLabel(device) {
    if (device.platform === "web") {
        const browser = clean(device.browserName) ?? "Browser";
        return `${browser} on ${webOperatingSystemLabel(device.operatingSystem)}`;
    }
    const displayName = clean(device.displayName);
    if (displayName)
        return displayName;
    // expo-device already supplies the consumer model name on iOS. Android
    // modelCode is deliberately never rendered because it is usually a part code.
    if (device.platform === "ios") {
        return (clean(device.modelCode) ??
            (device.formFactor === "tablet"
                ? "iPad"
                : device.formFactor === "phone"
                    ? "iPhone"
                    : "Device"));
    }
    const manufacturer = titleCaseManufacturer(device.manufacturer) ?? "Android";
    return `${manufacturer} ${formFactorLabel(device.formFactor)}`;
}
/** Model-free word an owner naturally uses when a device is named in a sentence. */
export function spokenDeviceName(device) {
    if (!device)
        return "device";
    if (device.formFactor === "tv")
        return "TV";
    const operatingSystem = device.operatingSystem.trim().toLowerCase();
    if (operatingSystem === "macos" || operatingSystem === "mac os")
        return "Mac";
    if (operatingSystem === "windows")
        return "PC";
    if (operatingSystem === "ipados")
        return "iPad";
    if (operatingSystem === "ios" || device.platform === "ios") {
        if (device.formFactor === "tablet")
            return "iPad";
        if (device.formFactor === "phone")
            return "iPhone";
        return "device";
    }
    if (operatingSystem === "android" || device.platform === "android") {
        if (device.formFactor === "phone")
            return "phone";
        if (device.formFactor === "tablet")
            return "tablet";
    }
    return "device";
}
